import { defaultInitialState } from '../utils';
import { NEW_USER_TOKEN, LOGIN_USER, LOGIN_USER_DONE, LOGIN_USER_ERR, LOGOUT_USER, GET_USER_STATUS, GET_USER_STATUS_DONE, GET_USER_STATUS_ERR, GET_OWNER_STATUS, GET_OWNER_STATUS_DONE, GET_OWNER_STATUS_ERR, DELETE_USER, DELETE_USER_DONE, DELETE_USER_ERROR, REMOVE_USER_ERROR, MEMBERSHIP_PAYMENT_FAILED_MODAL_VIEWED, GET_NEW_USER_STATUS, HERO_FILL_ACTIVATED, SELECT_HERO_ACCOUNT } from './actionTypes';
import { START_SESSION_DONE } from '../sessions/actionTypes';
import { ACTIVATE_USER_DONE } from '../userActivation/actionTypes';
import { SWITCH_ACCOUNT_DONE } from '../accountSwitch/actionTypes';
import { RECONNECT_HERO_DONE } from '../accountReconnect/actionTypes';
import { UPDATE_ACCOUNT_DETAILS_DONE } from '../accountDetailsUpdate/actionTypes';
import { SET_DATA_OPTOUT_DONE } from '../accountDataOptout/actionTypes';
const initialStatus = {
    sessions: [],
    is_activated: null,
    is_active: null,
    is_owner: null,
    is_fre: null
};
const initialState = Object.assign(Object.assign({}, defaultInitialState), { name: null, email: null, status: initialStatus, access_token: null, refresh_token: null, expires_in: null, obtain_time: null, getStatusTimestamp: null, membershipPaymentFailedModalViewed: false });
// eslint-disable-next-line complexity
const reducer = (state = initialState, action) => {
    switch (action.type) {
        // Login
        case LOGIN_USER:
            return Object.assign(Object.assign({}, state), { isLoading: true });
        case NEW_USER_TOKEN:
            return Object.assign(Object.assign({}, state), { access_token: action.data.access_token, refresh_token: action.data.refresh_token, expires_in: action.data.expires_in, obtain_time: action.data.obtain_time, isLoading: false, error: false });
        case ACTIVATE_USER_DONE:
            return Object.assign(Object.assign({}, state), { status: Object.assign(Object.assign({}, state.status), { is_activated: true }) });
        case LOGIN_USER_DONE:
            return Object.assign(Object.assign({}, state), { name: action.data.email, email: action.data.email, access_token: action.data.access_token, refresh_token: action.data.refresh_token, expires_in: action.data.expires_in, obtain_time: action.data.obtain_time, isLoading: false, error: false, errorMessage: null, status: Object.assign(Object.assign(Object.assign({}, state.status), action.data.status), { getStatusTimestamp: Date.now() }) });
        case LOGIN_USER_ERR:
            return Object.assign(Object.assign({}, state), { name: null, access_token: null, refresh_token: null, expires_in: null, isLoading: false, obtain_time: null, error: true, errorMessage: action.data.msg, status: {
                    sessions: [],
                    is_activated: null,
                    is_active: null,
                    is_owner: null,
                    is_fre: null
                } });
        // Logout
        case LOGOUT_USER:
            return initialState;
        // New session id
        case START_SESSION_DONE:
            return Object.assign(Object.assign({}, state), { status: Object.assign(Object.assign({}, state.status), { sessions: [{ status: 'started', session_id: action.data.session_id }], is_activated: state.status.is_activated, is_active: state.status.is_active, is_owner: state.status.is_owner, is_fre: state.status.is_fre }) });
        // Status and configs
        case GET_USER_STATUS:
        case GET_NEW_USER_STATUS:
        case GET_OWNER_STATUS:
            return Object.assign(Object.assign({}, state), { isLoading: true });
        case GET_USER_STATUS_ERR:
        case GET_OWNER_STATUS_ERR:
            return Object.assign(Object.assign({}, state), { isLoading: false, error: true, errorMessage: null });
        case SWITCH_ACCOUNT_DONE:
        case GET_USER_STATUS_DONE:
            return Object.assign(Object.assign({}, state), { isLoading: false, status: Object.assign(Object.assign(Object.assign({}, state.status), action.data), { getStatusTimestamp: Date.now() }) });
        case GET_OWNER_STATUS_DONE:
            return Object.assign(Object.assign({}, state), { isLoading: false, ownerStatus: Object.assign(Object.assign({}, action.data), { getStatusTimestamp: Date.now() }) });
        case SELECT_HERO_ACCOUNT:
            return Object.assign(Object.assign({}, state), { status: Object.assign(Object.assign({}, state.status), action.data) });
        case UPDATE_ACCOUNT_DETAILS_DONE:
            return Object.assign(Object.assign({}, state), { isLoading: false, status: Object.assign(Object.assign({}, state.status), action.data) });
        case RECONNECT_HERO_DONE:
            return Object.assign(Object.assign({}, state), { status: {
                    is_owner: true,
                    is_fre: true
                } });
        case MEMBERSHIP_PAYMENT_FAILED_MODAL_VIEWED:
            return Object.assign(Object.assign({}, state), { membershipPaymentFailedModalViewed: true });
        case HERO_FILL_ACTIVATED:
            return Object.assign(Object.assign({}, state), { status: Object.assign(Object.assign({}, state.status), { hero_fill_activated: true }) });
        // Data Opt-Out done
        case SET_DATA_OPTOUT_DONE:
            return Object.assign(Object.assign({}, state), { status: Object.assign(Object.assign({}, state.status), action.data) });
        // Delete user
        case DELETE_USER:
            return Object.assign(Object.assign({}, state), { isLoading: true });
        case DELETE_USER_DONE:
            return Object.assign(Object.assign({}, state), { isLoading: false, deleted: true });
        case DELETE_USER_ERROR:
            return Object.assign(Object.assign({}, state), { isLoading: false, error: true, errorMessage: action.data.msg });
        case REMOVE_USER_ERROR:
            return Object.assign(Object.assign({}, state), { error: false, errorMessage: null });
        default:
            return state;
    }
};
export default reducer;
//# sourceMappingURL=reducer.js.map